/* FABLE EDITORIAL — interactions (mirrors the approved HTML prototype) */
(function () {
  'use strict';

  /* scroll reveals */
  function initReveals() {
    var els = document.querySelectorAll('.fable-fx:not(.fable-fx--in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('fable-fx--in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('fable-fx--in');
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* count-up numbers (en-IN formatting: 1,16,484) */
  function initCounters() {
    document.querySelectorAll('[data-fable-count]').forEach(function (el) {
      if (el.__fableCount) return;
      el.__fableCount = true;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          io.disconnect();
          var target = parseInt(el.getAttribute('data-fable-count'), 10);
          var suffix = el.getAttribute('data-fable-suffix') || '';
          var t0 = null;
          function step(ts) {
            if (!t0) t0 = ts;
            var p = Math.min(1, (ts - t0) / 1400);
            var eased = 1 - Math.pow(1 - p, 3);
            el.textContent = Math.round(target * eased).toLocaleString('en-IN') + suffix;
            if (p < 1) requestAnimationFrame(step);
          }
          requestAnimationFrame(step);
        });
      }, { threshold: 0.4 });
      io.observe(el);
    });
  }

  /* hero mouse parallax */
  function initParallax() {
    document.querySelectorAll('.fable-hero').forEach(function (hero) {
      if (hero.__fablePar) return;
      hero.__fablePar = true;
      var media = hero.querySelector('.fable-hero__media');
      if (!media) return;
      hero.addEventListener('mousemove', function (e) {
        var r = hero.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        media.style.transform = 'translate(' + x * -16 + 'px,' + y * -11 + 'px)';
      });
      hero.addEventListener('mouseleave', function () {
        media.style.transform = 'translate(0,0)';
      });
    });
  }

  /* hero scroll cue */
  function initCue() {
    document.querySelectorAll('.fable-hero__cue').forEach(function (cue) {
      if (cue.__fableCue) return;
      cue.__fableCue = true;
      cue.addEventListener('click', function () {
        window.scrollBy({ top: window.innerHeight * 0.9, behavior: 'smooth' });
      });
    });
  }

  /* craft index hover preview */
  function initCraft() {
    document.querySelectorAll('.fable-craft').forEach(function (section) {
      if (section.__fableCraft) return;
      section.__fableCraft = true;
      var rows = section.querySelectorAll('.fable-craft__row');
      var imgs = section.querySelectorAll('.fable-craft__preview-img');
      var nameEl = section.querySelector('.fable-craft__preview-name');
      var ctaEl = section.querySelector('.fable-craft__preview-cta');
      rows.forEach(function (row, i) {
        row.addEventListener('mouseenter', function () {
          imgs.forEach(function (img, j) { img.classList.toggle('is-active', i === j); });
          if (nameEl) nameEl.textContent = row.getAttribute('data-craft-name') || '';
          if (ctaEl) ctaEl.setAttribute('href', row.getAttribute('href') || '#');
        });
      });
    });
  }

  /* featured slider arrows */
  function initSliders() {
    document.querySelectorAll('.fable-featured').forEach(function (section) {
      if (section.__fableSlider) return;
      section.__fableSlider = true;
      var row = section.querySelector('.fable-featured__row');
      if (!row) return;
      var prev = section.querySelector('[data-fable-prev]');
      var next = section.querySelector('[data-fable-next]');
      if (prev) prev.addEventListener('click', function () { row.scrollBy({ left: -588, behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { row.scrollBy({ left: 588, behavior: 'smooth' }); });
    });
  }

  /* video play (film + client stories) */
  function initVideos() {
    document.querySelectorAll('[data-fable-video]').forEach(function (wrap) {
      if (wrap.__fableVid) return;
      wrap.__fableVid = true;
      var overlay = wrap.querySelector('[data-fable-video-overlay]');
      var video = wrap.querySelector('video');
      if (!overlay || !video) return;
      overlay.addEventListener('click', function () {
        video.style.opacity = '1';
        video.controls = true;
        video.muted = false;
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
        overlay.style.display = 'none';
      });
    });
  }

  /* back to top */
  function initTop() {
    var btn = document.querySelector('.fable-top');
    if (!btn || btn.__fableTop) return;
    btn.__fableTop = true;
    window.addEventListener('scroll', function () {
      btn.classList.toggle('is-visible', window.scrollY > 600);
    }, { passive: true });
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  function initAll() {
    initReveals();
    initCounters();
    initParallax();
    initCue();
    initCraft();
    initSliders();
    initVideos();
    initTop();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  /* re-init after Shopify theme editor section reloads */
  document.addEventListener('shopify:section:load', initAll);
})();
